import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const REPORT_REASONS = ["spam", "inappropriate", "medical_claim", "other"];

export default function ReportDialog({ post, open, onClose }) {
  const { t } = useI18n();
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (open) { setReason(""); setDetails(""); setSent(false); }
  }, [open]);

  const submit = async () => {
    if (!post || !reason) return;
    try {
      await api.post(`/feed/report/${post.id}`, { reason, details });
      setSent(true);
      setTimeout(() => onClose(), 1200);
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="report-dialog">
        <DialogHeader><DialogTitle>{t("report_post_title")}</DialogTitle></DialogHeader>
        {sent ? (
          <p className="py-6 text-center text-sm font-medium text-emerald-600">{t("reported")}</p>
        ) : (
          <div className="space-y-3">
            {REPORT_REASONS.map((r) => (
              <button key={r} onClick={() => setReason(r)} data-testid={`report-reason-${r}`}
                className={`flex w-full items-center gap-2 rounded-xl border px-3 py-2.5 text-left text-sm transition-colors ${reason === r ? "border-primary bg-primary/5" : "border-border"}`}>
                <span className={`h-3.5 w-3.5 rounded-full border ${reason === r ? "border-primary bg-primary" : "border-muted-foreground"}`} />
                {t(`report_reason_${r}`)}
              </button>
            ))}
            <Textarea value={details} onChange={(e) => setDetails(e.target.value)} placeholder={t("description")} className="min-h-[70px]" data-testid="report-details" />
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={onClose} className="rounded-full" data-testid="report-cancel">{t("cancel")}</Button>
              <Button onClick={submit} disabled={!reason} className="rounded-full" data-testid="report-submit">{t("submit")}</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
